import * as _ from "lodash";
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Merchant from "domain/merchant";
import AddressEditor from "./AddressEditor";
import Address from "domain/address";
import ErrorList from "common/ui/ErrorList";
import { PhoneRegex, UrlRegex } from "common/validation";

export interface EditMerchantModalProps {
    merchant: Merchant;
    onSave(merchant: Merchant): void;
    onHide(): void;
    validationErrors: string[];
}

const EditMerchantModal: React.FC<EditMerchantModalProps> = props => {
    const [merchant, setMerchant] = useState<Merchant>(props.merchant);
    const [isValidated, setIsValidated] = useState(false);

    const formRef = React.createRef<HTMLFormElement>();

    function onSave() {
        if (formRef.current.checkValidity()) { 
            props.onSave(merchant);
        }
        setIsValidated(true);
    }

    function setAddress(address: Address){
        setMerchant({...merchant, mailingAddress: address})
    }

    return <Modal show onHide={props.onHide} backdrop="static" size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    Edit Merchant
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Form validated={isValidated} ref={formRef} >
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={merchant.name}
                                onChange={(event: any) => setMerchant({...merchant, name: event.target.value})}
                                required
                            />
                            <Form.Control.Feedback type="invalid">Merchant name is required.</Form.Control.Feedback>
                        </Form.Group>

                        <div className="row">
                            <div className="col">
                                <Form.Group>
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={merchant.email}
                                        onChange={(event: any) => setMerchant({...merchant, email: event.target.value?.trim()})}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">Valid email is required.</Form.Control.Feedback>
                                </Form.Group>
                            </div>
                            <div className="col">
                                <Form.Group>
                                    <Form.Label>Phone Number</Form.Label>
                                        <Form.Control
                                        type="text"
                                        name="phone"
                                        pattern={PhoneRegex.source}
                                        value={merchant.phone}
                                        onChange={(event: any) => setMerchant({...merchant, phone: event.target.value?.trim()})}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">Valid phone number is required.</Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <Form.Group>
                                    <Form.Label className="optional">Website URL</Form.Label>
                                        <Form.Control
                                        type="text"
                                        name="websiteUrl"
                                        pattern={UrlRegex.source}
                                        placeholder="https://"
                                        value={merchant.websiteUrl}
                                        onChange={(event: any) => setMerchant({...merchant, websiteUrl: event.target.value?.trim()})}
                                    />
                                    <Form.Control.Feedback type="invalid">Invalid URL format (must start with http:// or https://)</Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </div>

                        <h4>Mailing Address</h4>

                        <AddressEditor
                            address={merchant.mailingAddress}
                            setAddress={setAddress}
                        />
                    </Form>
                    
                    <ErrorList errors={props.validationErrors} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="pull-right">
                    <Button variant="secondary" className="ml-2" onClick={props.onHide}>
                        Cancel
                    </Button>&nbsp;
                    <Button variant="primary" onClick={onSave}>
                        Save
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
}

export default EditMerchantModal;